import { inject, Injectable, OnDestroy, signal, WritableSignal } from '@angular/core';
import { configureCache, GrowthBook, WidenPrimitives } from "@growthbook/growthbook";
import { environment } from 'src/environments/environment';
import { accountexternal } from '../client/client';
import { MixpanelService } from '../mix-panel.service/mix-panel.service';

@Injectable({
  providedIn: 'root'
})
export class GrowthbookService implements OnDestroy {
  private mixpanel = inject(MixpanelService);
  private gb: WritableSignal<GrowthBook | undefined> = signal(undefined);

  public async initGrowthBook(user: accountexternal.GetUserResponse | null, isStaff?: boolean) {
    if (!environment?.growthbook) return;
    if (this.gb()) this.logOut();

    this.gb.set(new GrowthBook({
      apiHost: environment?.growthbook?.apiHost,
      clientKey: environment?.growthbook?.clientKey,
      enableDevMode: !environment.production,
      attributes: {
        id: user?.doc_id,
        platform: 'web'
      },
      trackingCallback: (experiment, result) => {
        if (isStaff || !result.inExperiment) return;

        this.mixpanel.setSuperProperties({ [`experiment.${result.featureId}`]: result.value });

        this.mixpanel.track("$experiment_started", {
          "experiment.id": experiment.key,
          "variant.id": result.variationId,
          $source: 'growthbook'
        })
      }
    }));

    return await this.gb()?.init({ streaming: true });
  }

  public logOut() {
    if (!this.gb()) {
      return;
    }
    this.gb()?.destroy();
    this.gb.set(undefined);
  }

  public experimentOn(experimentKey: string): boolean {
    return this.gb()?.isOn(experimentKey) || false;
  }

  public experimentValue<T = unknown>(experimentKey: string, defaultValue?: T): WidenPrimitives<T> | undefined {
    return this.gb()?.getFeatureValue<T | undefined, string>(experimentKey, defaultValue);
  }

  ngOnDestroy() {
    if (this.gb()) {
      this.gb()?.destroy();
    }
  }
}
